import React, { useState } from 'react';
import { Platform, View, StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

// Web platformunda DateTimePicker dinamik olarak import edilecek
let DateTimePicker = null;
if (Platform.OS !== 'web') {
  // Web dışı platformlarda yükleme
  // process is not defined hatasını önlemek için
  const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  if (!isBrowser) {
    try {
      // Native platformlarda kullanmak için
      DateTimePicker = require('@react-native-community/datetimepicker').default;
    } catch (error) {
      console.warn('DateTimePicker could not be loaded', error);
    }
  }
}

// Tek parça tarih seçici bileşen
const CustomDatePicker = ({ 
  value, 
  onChange, 
  mode = 'date',
  display = 'default',
  label = 'Tarih Seç',
  placeholder = 'GG/AA/YYYY',
  error = false,
  helperText = '',
  disabled = false,
  maximumDate,
  minimumDate
}) => {
  const [showPicker, setShowPicker] = React.useState(false);
  
  // Tarih formatı
  const formatDate = (date) => {
    if (!date) return placeholder;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    if (mode === 'date') {
      return `${day}.${month}.${year}`;
    } else if (mode === 'time') {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    }
    
    return `${day}.${month}.${year}`;
  };
  
  // Tarih değişiklik işleyicisi
  const handleChange = (event, selectedDate) => {
    setShowPicker(Platform.OS === 'ios');
    
    if (selectedDate) {
      onChange(selectedDate);
    }
  };
  
  const openPicker = () => {
    if (!disabled) {
      setShowPicker(true);
    }
  };
  
  // Web platformu için input render
  if (Platform.OS === 'web') {
    return (
      <View style={styles.container}>
        <Text style={[styles.label, error && styles.errorLabel]}>{label}</Text>
        <View 
          style={[
            styles.inputContainer, 
            error && styles.errorBorder,
            disabled && styles.disabledInput
          ]}
        >
          <input
            type={mode}
            value={value ? value.toISOString().split('T')[0] : ''}
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              onChange(selectedDate);
            }}
            style={{
              flex: 1,
              fontSize: 16,
              border: 'none',
              outline: 'none',
              width: '100%',
            }}
            disabled={disabled}
            max={maximumDate ? maximumDate.toISOString().split('T')[0] : undefined}
            min={minimumDate ? minimumDate.toISOString().split('T')[0] : undefined}
          />
        </View>
        {error && helperText ? (
          <Text style={styles.errorText}>{helperText}</Text>
        ) : null}
      </View>
    );
  }
  
  // Native platformlar için render
  return (
    <View style={styles.container}>
      <Text style={[styles.label, error && styles.errorLabel]}>{label}</Text>
      <TouchableOpacity
        style={[
          styles.inputContainer, 
          error && styles.errorBorder,
          disabled && styles.disabledInput
        ]}
        onPress={openPicker}
        disabled={disabled}
      >
        <Text style={[styles.dateText, error && styles.errorText]}>
          {formatDate(value)}
        </Text>
        <MaterialCommunityIcons name="calendar" size={20} color="#666" style={styles.icon} />
      </TouchableOpacity>
      
      {error && helperText ? (
        <Text style={styles.errorText}>{helperText}</Text>
      ) : null}
      
      {showPicker && DateTimePicker && (
        <DateTimePicker
          value={value || new Date()}
          mode={mode}
          display={display}
          onChange={handleChange}
          maximumDate={maximumDate}
          minimumDate={minimumDate}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
    width: '100%',
  },
  label: {
    marginBottom: 8,
    fontSize: 14,
    color: '#666',
  },
  errorLabel: {
    color: '#B00020',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    backgroundColor: '#fff',
  },
  errorBorder: {
    borderColor: '#B00020',
  },
  disabledInput: {
    backgroundColor: '#f0f0f0',
    opacity: 0.7,
  },
  dateText: {
    fontSize: 16,
    color: '#000',
  },
  errorText: {
    color: '#B00020',
    fontSize: 12,
    marginTop: 4,
  },
  icon: {
    marginLeft: 8,
  },
});

export default CustomDatePicker;
